<template>
  <div class="sign-up-complete">

    <header-bar></header-bar>

    <section class="background-image">
      <div class="grid-container">
        <div class="col-4">
          <h2>Thanks {{ this.$root.profile.firstname }}!</h2>
          <p>You're profile is now complete.</p>
          <p>You can match, connect, exchange and make big ideas for Africa happen!</p>

          <router-link to="/matches" class="btn btn-big bg-four active">Discover your matches</router-link>
        </div>
      </div>
    </section>


  </div>
</template>

<script>
import { db } from '@/firebase'
import HeaderBar from '@/components/HeaderBar'

export default {
  data () {
    return {
    }
  },
  components: {
    HeaderBar
  },
  methods: {
    save () {
      console.log('Save initiated')
      let userData = this.userRegData
      let timestamp = Date.now()
      delete userData['.key']

      let focusArea = userData.personality['focus-areas']
      let haveSkills = userData.personality['have-skills']
      let countries = userData.personality['countries']
      let userObj = {[this.$root.user.uid]: true}
      let userSlug = {[userData.slug]: this.$root.user.uid}

      // Add focus areas
      if (focusArea) {
        for (let item in focusArea) {
          db.ref('attributes/focus-areas/' + item + '/users').update(userObj)
        }
      }

      // Add skills
      if (haveSkills) {
        for (let item in haveSkills) {
          db.ref('attributes/skills/' + item + '/users').update(userObj)
        }
      }

      // Add countries
      if (countries) {
        for (let item in countries) {
          db.ref('attributes/countries/' + item + '/users').update(userObj)
        }
      }

      // Add slug
      db.ref('user-meta/slug').update(userSlug)

      let parent = this
      db.ref('users/' + this.$root.user.uid).set(userData, function () {
        // On complete
        console.log('saved')
        db.ref('users-registration/' + parent.$root.user.uid).remove()
      })

      // Add notification
      db.ref('user-meta/notifications/' + this.$root.user.uid).push({
        from: 'pei',
        content: 'Thanks for signing up! Enjoy exploring!',
        createdAt: timestamp
      })
    }
  },
  firebase: function () {
    return {
      userRegData: {
        source: db.ref('users-registration/' + this.$root.user.uid),
        asObject: true
      }
    }
  },
  mounted () {
    this.save()
  }
}
</script>



// WEBPACK FOOTER //
// Register-Step-10.vue?61a28e9a